import React from 'react';
import { useIntl } from 'react-intl-next';
import { AutoDismissFlag, FlagGroup } from '@atlaskit/flag';
import SuccessIcon from '@atlaskit/icon/core/success';
import { messages } from './messages';
export var DefinitionUpdateConfirmationFlag = function DefinitionUpdateConfirmationFlag(_ref) {
  var _onDismissed = _ref.onDismissed;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  return /*#__PURE__*/React.createElement(FlagGroup, {
    onDismissed: function onDismissed() {
      return _onDismissed();
    }
  }, /*#__PURE__*/React.createElement(AutoDismissFlag, {
    id: "definition-update-success-adflag",
    title: formatMessage(messages.edit_definition_update_confirmation_title),
    description: formatMessage(messages.edit_definition_update_confirmation_description),
    icon: /*#__PURE__*/React.createElement(SuccessIcon, {
      label: "Success",
      color: "var(--ds-icon-success, #22A06B)"
    })
  }));
};